import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { IMPLANT_CONSULTATION_AND_FINDINGS } from '../../../../anamnesis/state/anamnesis/const'
import { IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT } from '../../../../anamnesis/state/anamnesis/const'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectImageVersionList } from '../../../../customer/state/image/selector'
import { selectAnamnesisList } from '../../../../anamnesis/state/anamnesis/selector'
export default createUIDefinition({
    taskName: taskName.IMPLANT_MEDICAL_CHECK,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
            widgetProps: {
                excludeTemplateKeyList: [
                    IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT,
                    IMPLANT_CONSULTATION_AND_FINDINGS
                ],
            },
        },
        {
            component: processUI.ANAMNESIS_EDIT_WIDGET_CONTAINER,
            widgetProps: {
                templateKey: IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT,
            },
        },
        {
            component: processUI.ANAMNESIS_EDIT_WIDGET_CONTAINER,
            widgetProps: {
                templateKey: IMPLANT_CONSULTATION_AND_FINDINGS,
            },
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.CUSTOMER_IMAGE_UPLOAD_WIDGET,
            widgetProps: {
                skipImages: [
                    'lower-row-of-teeth',
                    'upper-row-with-aligner',
                    'lower-row-with-aligner',
                ],
            },
        },
        {
            component: processUI.PATIENT_SCANNED_WIDGET,
            widgetProps: {
                isSaveNeeded: true,
            }
        },
        {
            component: processUI.TRANSITION_LIST_WIDGET_CONTAINER,
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
        selectImageVersionList,
        selectAnamnesisList,
    ],
    taskValidator: (
        task,
        processInstance,
        taskName,
        eventName,
        context,
        imageVersionList
    ) => {
        const messageList = []

        if (context.patientScanned === undefined) {
            messageList.push(
                createValidationMessage(
                    'Please select, if you have scanned the customer.',
                    'patientScanned'
                )
            )
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/implant-3dscan/implant-medical-check.js